import { render, staticRenderFns } from "./MarketingAutomationFormPanelEntrySectionLocal.vue?vue&type=template&id=8c0367c4&scoped=true"
import script from "./MarketingAutomationFormPanelEntrySectionLocal.vue?vue&type=script&lang=js"
export * from "./MarketingAutomationFormPanelEntrySectionLocal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c0367c4",
  null
  
)

export default component.exports